import { useState } from 'react'
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
    InputButtonContainer
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Button } from '../../../components/button'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Link } from 'react-router-dom';
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Textarea } from '../../../components/textarea/textarea'


const LibraryUpload = () => {
    const [imageUploadValue, setImageUploadValue] = useState('')

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Library
                        </Heading>
                        <Breadcrumb
                            crumbs={['library', 'upload']}
                        />
                        <form>
                            <InputWrapper>
                                <Input
                                    id="fileName"
                                    label="FILE NAME"
                                    type="text"
                                    placeholder="English Language"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Textarea
                                    id="libraryUploadDescription"
                                    label="DESCRIPTION"
                                    type="text"
                                    placeholder="Description"
                                    fullWidth
                                />
                            </InputWrapper>
                            {/* TODO: SELECT COMPONENT */}
                            <InputWrapper>
                                <InputButtonContainer>
                                    <Input value={imageUploadValue} type='text' placeholder="Choose file" fullWidth />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </InputButtonContainer>
                            </InputWrapper>
                            <InputWrapper>
                                <InputButtonContainer>
                                    <Input value={imageUploadValue} type='text' placeholder="Choose cover image" fullWidth />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </InputButtonContainer>
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                UPLOAD
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default LibraryUpload
